import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Card,
  CardContent,
  Button,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  IconButton,
  Grid,
} from "@material-ui/core";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import GetAppIcon from "@material-ui/icons/GetApp";
import DescriptionIcon from "@material-ui/icons/Description";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import PhotoSizeSelectActualOutlinedIcon from "@material-ui/icons/PhotoSizeSelectActualOutlined";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../js/reducers/snackbar";
import { OAuth as OAuthActions } from "../../js/actions";
import * as _ from "lodash";
import moment from "moment";
import Viewer from "react-viewer/dist/index.js";
import * as axios from "axios";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import JSZip from "jszip";
import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
  Image,
  pdf,
} from "@react-pdf/renderer";
import Bosch_Regular from "../../../src/assets/fonts/BoschSans-Regular-v5_003.ttf";
import { boschBanner, Bosch_Logo_Png, createInspectionJob } from "../../assets/images";
import MenuIcon from "@material-ui/icons/Menu";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

Font.register({
  family: "BoschRegular",
  fonts: [
    { src: Bosch_Regular, fontWeight: "normal" },
    { src: Bosch_Regular, fontWeight: "bold" },
  ],
});

// Status enum for inspection topics
const TOPIC_STATUS = {
  PASS: "PASS",
  FAIL: "FAIL",
  YET_TO_START: "YET_TO_START",
  NA: "NA",
};

const COLORS = {
  blue100: "#dbeafe",
  blue700: "#1d4ed8",
};


// Status display text mapping
const STATUS_DISPLAY_TEXT = {
  [TOPIC_STATUS.PASS]: "Pass",
  [TOPIC_STATUS.FAIL]: "Fail",
  [TOPIC_STATUS.YET_TO_START]: "Yet to start",
  [TOPIC_STATUS.NA]: "Not Available",
};

// PDF Styles
const BORDER_COLOR = "#bfbfbf";
const BORDER_STYLE = "solid";
const COL1_WIDTH = 40;
const COLN_WIDTH = (100 - COL1_WIDTH) / 3;

const pdfStyles = StyleSheet.create({
  body: {
    marginTop: 10,
    marginBottom: 10,
    flexGrow: 1,
  },
  body_chapter: {
    marginTop: 0,
    paddingHorizontal: 10,
    marginTop: 10,
    marginBottom: 10,
    flexGrow: 1,
  },
  header: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
  },
  page: {},
  headerBanner: {
    width: "100%",
    height: 5,
    position: "absolute",
    left: 0,
    top: 0,
  },

  pageIconBox: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: COLORS.blue100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },

  pageTitleIcon: {
    fontSize: 20,
    color: COLORS.blue700,
  },

  panelHeaderLeft: {
    display: "flex",
    alignItems: "center",
    minWidth: 0,
  },
  panelTitle: {
    fontWeight: 700,
    fontSize: "0.82rem !important",
    letterSpacing: "-0.005em",
  },
  title: {
    fontSize: 24,
    margin: 12,
    textAlign: "center",
    fontWeight: "bold",
    textDecoration: "underline",
  },
  subtitle: {
    fontSize: 16,
    marginVertical: 10,
    fontWeight: "bold",
    textDecoration: "underline",
  },
  page_listview: {
    paddingHorizontal: 0,
    paddingTop: 40,
    paddingBottom: 35,
  },
  subtitle_content: {
    fontSize: 16,
    fontWeight: "bold",
    marginVertical: 10,
    marginLeft: 10,
  },
  text: {
    margin: 2,
    fontSize: 12,
    textAlign: "justify",
  },
  image: {
    marginVertical: 5,
    marginHorizontal: 5,
    width: "auto",
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    marginTop: 10,
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row",
  },
  tableCol1Header: {
    width: COL1_WIDTH + "%",
    backgroundColor: "#bfbfbf",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableColHeader: {
    width: COLN_WIDTH + "%",
    backgroundColor: "#bfbfbf",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol1: {
    width: COL1_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCol: {
    width: COLN_WIDTH + "%",
    borderStyle: BORDER_STYLE,
    borderColor: BORDER_COLOR,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCellHeader: {
    margin: 5,
    fontSize: 12,
    fontWeight: 500,
  },
  tableCell: {
    margin: 5,
    fontSize: 10,
  },
  table1: {
    display: "table",
    width: "auto",
    marginBottom: 10,
    marginLeft: 10,
    marginRight: 10,
  },
  tableRow1: {
    flexDirection: "row",
  },
  header_1: {
    display: "flex",
    justifyContent: "space-between",
    padding: 10,
    borderBottom: "1px solid #ddd",
    marginBottom: 20,
  },
  leftView_1: {
    flex: 1,
  },
  rightView_1: {
    flex: 0,
    width: 150,
  },
  chapterContainer: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 5,
    border: "1px solid #ddd",
    fontSize: 9,
  },
  row: {
    display: "flex",
    flexDirection: "row",
  },
  column: {
    display: "flex",
    flexDirection: "row",
    paddingVertical: 3,
    width: "50%",
    paddingLeft: 5,
  },
  label: {
    width: 50,
    color: "#4b4b4b",
    paddingVertical: 5,
    borderBottom: "1px solid #ddd",
    paddingLeft: 5,
    fontWeight: "bold",
  },
  label_dot: {
    width: 10,
    color: "#4b4b4b",
    paddingVertical: 5,
    borderBottom: "1px solid #ddd",
    fontWeight: "bold",
  },
  value: {
    flex: 1,
    flexWrap: "wrap",
    paddingLeft: 5,
    paddingVertical: 5,
    borderBottom: "1px solid #ddd",
  },
  imageContainer: {
    display: "flex",
    flexDirection: "column",
    paddingVertical: 3,
    width: "100%",
  },
  imageRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    paddingLeft: 5,
    width: "100%",
  },
  imageSize: {
    width: "100%",
    margin: 5,
  },
  noImages: {
    color: "red",
  },
  images_reference: {
    flexDirection: "row",
    flexWrap: "wrap",
    paddingLeft: 5,
    width: "100%",
  },
  header_list: {
    position: "absolute",
    minHeight: 40,
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    borderBottom: "1px solid #ddd",
  },
  logo_1: {
    width: 150,
    height: "auto",
    marginLeft: "auto",
  },
  headerBanner_list: {
    borderRight: "1px solid #ddd",
    paddingRight: 30,
    paddingTop: 30,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title_list: {
    fontSize: 10,
    textAlign: "left",
    paddingLeft: 10,
    fontWeight: "bold",
    alignSelf: "center",
    marginTop: 4,
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    borderTop: "1px solid #ddd",
  },
  footer_text: {
    fontSize: 8,
    paddingLeft: 20,
    marginVertical: 10,
    textAlign: "left",
  },
  infoText: {
    fontSize: 8,
    textAlign: "left",
    maxWidth: "60%",
    marginTop: 5,
  },
  title_head: {
    fontSize: 24,
    textAlign: "left",
    paddingLeft: 30,
    paddingTop: 30,
    fontWeight: "bold",
  },
  detailLabel: {
    color: "#808080",
  },
  pageNumber: {
    fontSize: 9,
    marginLeft: "auto",
    paddingRight: 10,
  },
});

const useStyles = makeStyles((theme) => ({
  page: {
    minHeight: "100vh",
    padding: "24px",
    margin: "0 auto",
    backgroundColor: "#f0f2f7",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 24,
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 12,
  },
  headerIcon: {
    width: 40,
    height: 40,
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: "24px !important",
    fontWeight: 700,
    color: "#0f172a",
    letterSpacing: -0.4,
  },
  exportBtn: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 14px",
    background: "linear-gradient(135deg, #1a56db 0%, #1e40af 100%)",
    color: "#fff",
    borderRadius: 10,
    fontSize: "14px !important",
    fontWeight: 600,
    boxShadow: "0 2px 8px rgba(26, 86, 219, 0.35)",
    textTransform: "none",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 4px 16px rgba(26, 86, 219, 0.45)",
    },
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    boxShadow: "0 1px 4px rgba(0,0,0,0.06), 0 4px 20px rgba(0,0,0,0.05)",
    marginBottom: 20,
  },
  pageIconBox: {
    width: 40,
    height: 40,
    borderRadius: 12,
    backgroundColor: COLORS.blue100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },

  pageTitleIcon: {
    fontSize: "22px !important",
    color: COLORS.blue700,
  },

  infoTitle: {
    fontSize: "13px !important",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#1a56db",
    marginBottom: 4,
  },
  fieldRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: 8,
  },
  fieldLabel: {
    fontSize: "13px !important",
    fontWeight: 600,
    color: "#64748b",
    minWidth: 110,
    paddingTop: 1,
  },
  fieldValue: {
    fontSize: "13px !important",
    fontWeight: 500,
    color: "#0f172a",
    background: "#f8fafc",
    padding: "3px 10px",
    borderRadius: 6,
    border: "1px solid #e2e8f0",
    wordBreak: "break-all",
  },
  fieldValue1: {
    fontSize: "13px !important",
    fontWeight: 500,
    color: "#0f172a"
  },
  detailsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 0,
  },
  detailCell: {
    padding: "20px 24px",
    borderRight: "2px solid #f1f5f9",
    "&:last-child": {
      borderRight: "none",
    },
  },
  detailCellLabel: {
    fontSize: "13px !important",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: 0.8,
    color: "#94a3b8",
    marginBottom: 6,
  },
  detailCellValue: {
    fontSize: "13px !important",
    fontWeight: 600,
    color: "#0f172a",
  },
  detailsDates: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 0,
    borderTop: "1px solid #f1f5f9",
  },
  dividerLine: {
    height: 1,
    background: "linear-gradient(to right, transparent, #e2e8f0, transparent)",
    margin: 0,
  },
  chapterHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0px 28px 0px 0px",
    background: "linear-gradient(to right, #f8faff, #f0f4ff)",
    borderBottom: "1px solid #e8edfa",
  },
  chapterActions: {
    display: "flex",
    alignItems: "center",
    gap: 20,
  },
  expandBtn: {
    fontSize: "13px !important",
    fontWeight: 600,
    color: "#1a56db",
    background: "none",
    border: "1.5px solid #1a56db",
    borderRadius: 8,
    padding: "6px 14px",
    cursor: "pointer",
    transition: "all 0.18s",
    textTransform: "none",
    "&:hover": {
      background: "#1a56db",
      color: "#fff",
    },
  },
  radioGroup: {
    display: "flex",
    alignItems: "center",
    gap: 16,
    fontSize: "13px !important",
    color: "#475569",
  },
  radioOption: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
    fontWeight: 500,
  },
  radioDot: {
    width: 18,
    height: 18,
    borderRadius: "50%",
    border: "2px solid #cbd5e1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "border-color 0.18s",
    "&.active": {
      borderColor: "#1a56db",
    },
  },
  cardFlexContainer: {
    display: "flex !important",
  },
  gridImageContainer: {
    height: "100% !important",
    width: "100% !important",
    minHeight: "140px !important",
    objectFit: "cover !important",
  },
  cardContentContainer: {
    flex: "1 !important",
    display: "flex !important",
    flexDirection: "column !important",
    gap: "14px !important",
  },
  moreDetailsHeader: {
    padding: "14px 24px !important",
    borderBottom: "1px solid #f1f5f9 !important",
    display: "flex !important",
    alignItems: "center !important",
    backgroundColor: "#F5F8FF !important",
  },
  moreDetailsTitle: {
    fontSize: "13px !important",
    fontWeight: "700 !important",
    color: "#1a56db !important",
    textTransform: "uppercase !important",
    letterSpacing: "0.8px !important",
  },
  detailCellWithBorder: {
    borderRight: "2px solid #f1f5f9 !important",
    "&:last-child": {
      borderRight: "none !important",
    },
  },

  noRecordsContainer: {
    display: "flex !important",
    justifyContent: "center !important",
    padding: "2rem !important",
  },
  noRecordsText: {
    fontSize: "14px !important",
  },
  radioDotActive: {
    width: "8px !important",
    height: "8px !important",
    borderRadius: "50% !important",
    background: "#1a56db !important",
  },
  radioDotBorder: {
    borderColor: "#1a56db !important",
    position: "relative !important",
  },
  radioDotBorderInactive: {
    borderColor: "#cbd5e1 !important",
    position: "relative !important",
  },
  // Accordion styles
  accordionItem: {
    borderBottom: "1px solid #e2e8f0",
  },
  accordionItemLast: {
    borderBottom: "none",
  },
  accordionTrigger: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 24px",
    background: "none",
    border: "none",
    cursor: "pointer",
    textAlign: "left",
    fontSize: "14px !important",
    fontWeight: 600,
    color: "#1e293b",
    transition: "background 0.15s",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    "&:hover": {
      background: "#f8fafc",
    },
  },
  accordionChevron: {
    transition: "transform 0.25s",
  },
  accordionChevronOpen: {
    transform: "rotate(180deg)",
  },
  accordionContent: {
    overflow: "hidden",
    transition: "max-height 0.3s ease",
  },
  tableWrap: {
    padding: "4px 24px 20px",
  },
  table: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    border: "1px solid #e2e8f0",
    borderRadius: 10,
    overflow: "hidden",
    fontSize: "14px !important",
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    backgroundColor: "#F4F7FF",
  },
  tableHeadRow: {
    background: "#1E44B6",
  },
  tableHeader: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: "12px !important",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 0.7,
    color: "white",
    borderBottom: "1px solid #e2e8f0",
  },
  tableCell: {
    padding: "14px 16px",
    borderBottom: "1px solid #e2e8f0",
    color: "#334155",
    verticalAlign: "middle",
  },
  tableRowHover: {
    "&:hover td": {
      background: "#dbeafe",
    },
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "5px 12px",
    borderRadius: 20,
    fontSize: "11px !important",
    fontWeight: 700,
    letterSpacing: 0.4,
    textTransform: "uppercase",
  },
  badgeYellow: {
    background: "#fef9c3",
    color: "#854d0e",
    border: "1px solid #fde047",
  },
  badgeGreen: {
    background: "#dcfce7",
    color: "#166534",
    border: "1px solid #86efac",
  },
  badgeRed: {
    background: "#fee2e2",
    color: "#991b1b",
    border: "1px solid #fca5a5",
  },
  iconBtn: {
    background: "#f1f5f9",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: "6px 8px",
    cursor: "pointer",
    color: "#64748b",
    transition: "all 0.15s",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 4,
    "&:hover": {
      background: "#e0e7ff",
      color: "#1a56db",
      borderColor: "#a5b4fc",
    },
  },
}));

export default function JobDetails(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const userRole = useSelector((state) => state?.OAuth?.roles);

  // State for job details
  const [details, setDetails] = useState({
    jobId: "",
    modelName: "",
    market: "",
    year: "",
    plantDetails: "",
    inspectionDate: "",
    endDate: "",
    status: "",
    technicians: "",
    vin: "",
  });

  const [chapters, setChapters] = useState([]);
  const [chaptersData, setChaptersData] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [filterStatus, setFilterStatus] = useState("All");
  const [exportOptions, setExportOptions] = useState(false);
  const [exportType, setExportType] = useState("excel");
  const [exportValue, setExportValue] = useState("all");
  const [exportLoading, setExportLoading] = useState(false);

  // Image and PDF viewing
  const [imageVisible, setImageVisible] = useState(false);
  const [inspectImages, setInspectImages] = useState({});
  const [referenceHtmlUrl, setReferenceHtmlUrl] = useState(null);
  const [onPdfClick, setOnPdfClick] = useState(false);

  // Load document styles
  useEffect(() => {
    if (exportLoading) {
      document.body.classList.add("set-loading-indicator");
    } else {
      document.body.classList.remove("set-loading-indicator");
    }
  }, [exportLoading]);

  // Main data loading effect
  useEffect(async () => {
    if (!props || !props.location || !props.location.rowdata) {
      history.replace("/inspection-job");
      return;
    }

    try {
      await dispatch(OAuthActions.getJobById(props.location.rowdata.jobId)).then(
        function (jobDetails) {
          if (jobDetails && jobDetails.jobBasicDetailsDto) {
            const basic = jobDetails.jobBasicDetailsDto;
            setDetails({
              jobId: basic.jobId || "",
              modelName: basic.modelName || "",
              market: basic.market || "",
              year: basic.year || "",
              plantDetails: basic.plantDetails || "",
              inspectionDate: basic.inspectionDate || "",
              endDate: basic.endDate || "",
              status: basic.status || "",
              technicians: basic.technicianList
                ? basic.technicianList
                  .map((t) => `${t.firstName} ${t.lastName}`)
                  .join(", ")
                : "No Technicians Assigned",
              vin: jobDetails.vin || "No VIN Added",
            });

            if (jobDetails.chapters) {
              setChapters(jobDetails.chapters);
              setChaptersData(_.cloneDeep(jobDetails.chapters));
            }
          }
        }
      );
    } catch (error) {
      console.error("Error fetching job details:", error);
      dispatch(setSnackbar(true, "error", "Error loading job details"));
    }
  }, [props, history, dispatch]);

  // Helper functions
  const getTopicStatus = (result) => {
    if (result === null || result === "NULL" || result === undefined) {
      return TOPIC_STATUS.YET_TO_START;
    }
    if (result === true || result === "true") {
      return TOPIC_STATUS.PASS;
    }
    if (result === false || result === "false") {
      return TOPIC_STATUS.FAIL;
    }
    if (result === "NA") {
      return TOPIC_STATUS.NA;
    }
    return TOPIC_STATUS.YET_TO_START;
  };

  const getStatusText = (status) => {
    return STATUS_DISPLAY_TEXT[status] || STATUS_DISPLAY_TEXT[TOPIC_STATUS.YET_TO_START];
  };

  const isTopicFailed = (result) => {
    return getTopicStatus(result) === TOPIC_STATUS.FAIL;
  };

  const getImages = async (chapterImages) => {
    if (!chapterImages) return [];

    const imagePromises = chapterImages.map(async (image) => {
      const url = String(image);
      const imagePath = url.substring(url.lastIndexOf("/") + 1, url.lastIndexOf(".jpeg"));

      try {
        const response = await axios.get(image, { responseType: "blob" });
        if (response.data) {
          const file = new File([response.data], { type: "image/jpeg" });
          const imageUrl = URL.createObjectURL(file);
          return { src: imageUrl, filename: imagePath };
        }
      } catch (error) {
        console.error(`Error fetching image from ${url}:`, error);
        return { src: `Error: ${error.message}`, filename: imagePath };
      }
    });

    return Promise.all(imagePromises);
  };

  const getImageView = async (topicDetails) => {
    let allImageUrls = topicDetails.images;
    let images = [];
    if (allImageUrls && allImageUrls !== null) {
      for (const image of allImageUrls) {
        let axiosData = await axios({
          url: image,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            if (response.data !== null && response.data) {
              const file = new File([response.data], { type: "image/jpeg" });
              var imageUrl = URL.createObjectURL(file);
              return imageUrl;
            }
          })
          .catch(function (err) {
            console.error("Image fetch error:", err);
          });
        images.push({ src: axiosData });
      }
    }
    if (images.length > 0) {
      setInspectImages(images);
      setImageVisible(true);
    } else {
      dispatch(setSnackbar(true, "info", "No Images Present under this topic"));
    }
  };

  const getPDFView = (topicDetails) => {
    if (topicDetails?._links?.manualLink?.href) {
      const htmlUrl = topicDetails._links.manualLink.href;
      const urlObj = new URL(htmlUrl);
      const filePath = urlObj.searchParams.get("filePath");
      let correctedUrl = null;

      try {
        const singleDecoded = decodeURIComponent(filePath);
        const doubleDecoded = decodeURIComponent(singleDecoded);
        correctedUrl = `${urlObj.origin}${urlObj.pathname}?filePath=${encodeURIComponent(
          doubleDecoded
        )}`;
      } catch (decodeError) {
        // filePath not present or not encoded
      }

      axios({
        url: htmlUrl,
        method: "GET",
        responseType: "blob",
        timeout: 30000,
        headers: {
          Accept: "text/html,*/*",
        },
      })
        .then((response) => {
          if (response.data && response.data.size > 0) {
            const blob = new Blob([response.data], { type: "text/html" });
            const blobUrl = URL.createObjectURL(blob);
            setReferenceHtmlUrl(blobUrl);
            setOnPdfClick(true);
          } else {
            dispatch(setSnackbar(true, "error", "Reference file is empty or corrupted"));
          }
        })
        .catch((error) => {
          if (!correctedUrl) {
            throw error;
          }

          return axios({
            url: correctedUrl,
            method: "GET",
            responseType: "blob",
            timeout: 30000,
            headers: {
              Accept: "text/html,*/*",
            },
          })
            .then((response) => {
              if (response.data && response.data.size > 0) {
                const blob = new Blob([response.data], { type: "text/html" });
                const blobUrl = URL.createObjectURL(blob);
                setReferenceHtmlUrl(blobUrl);
                setOnPdfClick(true);
              } else {
                dispatch(setSnackbar(true, "error", "Reference file is empty or corrupted"));
              }
            });
        })
        .catch((finalError) => {
          const errorMessage =
            finalError.response?.status === 404
              ? "Reference file not found"
              : "Failed to load reference file. Please check your internet connection.";
          dispatch(setSnackbar(true, "error", `Error loading file: ${errorMessage}`));
        });
    } else {
      dispatch(setSnackbar(true, "info", "No reference file available for this topic"));
    }
  };

  const exportToCSVBlob = async (apiData) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

    const wsData = [
      ["Chapter", "Topic", "Remarks", "Results", "Topic Images"],
      ...apiData.map((item) => {
        const images = item.topicImage
          ? item.topicImage.split(",")
            .map((img) => img.trim())
            .filter(Boolean)
          : [];

        const row = [
          item.Chapter,
          item.topic,
          item.remarks,
          item.results,
          images.length > 0 ? { f: `HYPERLINK("./images/${images[0]}", "${images[0]}")` } : "-",
        ];

        for (let i = 1; i < images.length; i++) {
          if (images[i].startsWith("Error")) {
            row.push({ v: `Error: ${images[i]}` });
          } else {
            row.push({ f: `HYPERLINK("./images/${images[i]}", "${images[i]}")` });
          }
        }

        return row;
      }),
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    return new Blob([excelBuffer], { type: fileType });
  };

  const NewDocument = async () => {
    const allChapters = await Promise.all(
      chapters.map(async (chapter) => {
        const chapterName = chapter.name;
        const topics = await Promise.all(
          chapter.topics.map(async (topic) => {
            const topicData = {
              Chapter: chapterName,
              topic: topic.name,
              remarks: topic.remarks,
              topicImage: [],
              results: getStatusText(topic.result),
            };

            if (topic.images) {
              topicData.topicImage = await getImages(topic.images);
            }

            if (
              (exportValue === "failed" && isTopicFailed(topic.result)) ||
              exportValue === "all"
            ) {
              return topicData;
            }

            return null;
          })
        );

        return topics.filter((topic) => topic !== null);
      })
    );

    const flattenedChapters = allChapters.flat();

    if (flattenedChapters.length === 0) {
      dispatch(setSnackbar(true, "info", "No data present in the file to export"));
      setExportOptions(false);
      return null;
    }

    setExportOptions(false);

    return (
      <Document>
        <Page style={pdfStyles.page}>
          <View style={pdfStyles.header} fixed>
            <Image style={pdfStyles.headerBanner} src={boschBanner} />
            <View style={pdfStyles.headerBanner_list}>
              <Image src={Bosch_Logo_Png} style={pdfStyles.logo_1} />
              <Text style={pdfStyles.title_head}>Owners Manual Inspection Report</Text>
            </View>
          </View>
          <View style={{ justifyContent: "center", alignItems: "center", top: "25%" }}>
            <Text style={pdfStyles.subtitle}>Job Details:</Text>
            <View style={pdfStyles.table}>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Job Id :</Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>{details.jobId}</Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Technicians :</Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>{details.technicians}</Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>VIN Number :</Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>{details.vin}</Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Year : </Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>{details.year}</Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Model : </Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>{details.modelName}</Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Market : </Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>{details.market}</Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Plant : </Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>{details.plantDetails}</Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Inspection Start Date :</Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>
                    {details.inspectionDate
                      ? moment(details.inspectionDate).format("DD/MM/YYYY")
                      : ""}
                  </Text>
                </View>
              </View>
              <View style={pdfStyles.tableRow}>
                <View style={pdfStyles.tableCol}>
                  <Text style={pdfStyles.tableCell}>Inspection End Date :</Text>
                </View>
                <View style={pdfStyles.tableCol1}>
                  <Text style={pdfStyles.tableCell}>
                    {details.endDate ? moment(details.endDate).format("DD/MM/YYYY") : ""}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </Page>

        <Page style={[pdfStyles.page_listview]}>
          <View style={pdfStyles.header_list} fixed>
            <Image style={pdfStyles.headerBanner} src={boschBanner} />
            <Text style={[pdfStyles.title_list, { fontWeight: "bold" }]}>
              Inspection Job Report |{" "}
            </Text>
            <View style={pdfStyles.infoText}>
              <Text>
                {details.modelName} - {details.year} | Market: {details.market} |{" "}
                {details.plantDetails} : {details.inspectionDate
                  ? moment(details.inspectionDate).format("DD/MM/YYYY")
                  : ""}{" "}
                -{" "}
                {details.endDate ? moment(details.endDate).format("DD/MM/YYYY") : ""}
              </Text>
            </View>
            <Text
              style={pdfStyles.pageNumber}
              render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
              fixed
            />
          </View>

          <View style={[pdfStyles.body_chapter]}>
            <Text style={[pdfStyles.subtitle_content]}>Vehicle Inspection Details:</Text>

            {flattenedChapters.map((row, index) => (
              <View key={index} style={pdfStyles.chapterContainer}>
                <View style={pdfStyles.row}>
                  <Text style={pdfStyles.label}>Chapter </Text>
                  <Text style={pdfStyles.label_dot}>:</Text>
                  <Text style={pdfStyles.value}>{row.Chapter}</Text>
                </View>
                <View style={pdfStyles.row}>
                  <Text style={pdfStyles.label}>Topic </Text>
                  <Text style={pdfStyles.label_dot}>:</Text>
                  <Text style={pdfStyles.value}>{row.topic}</Text>
                </View>
                <View style={pdfStyles.row}>
                  <Text
                    style={[
                      pdfStyles.value,
                      {
                        color:
                          row.results === "Pass"
                            ? "green"
                            : row.results === "Fail"
                              ? "red"
                              : row.results === "Not Available"
                                ? "#ff8900"
                                : "black",
                      },
                    ]}
                  >
                    Results : {row.results}
                  </Text>
                </View>
                <View style={pdfStyles.row}>
                  <Text style={pdfStyles.label}>Remarks </Text>
                  <Text style={pdfStyles.label_dot}>:</Text>
                  <Text style={pdfStyles.value}>{row.remarks}</Text>
                </View>
                {row.topicImage && row.topicImage.length > 0 ? (
                  <View>
                    {row.topicImage.map((image, i) => (
                      <View key={`${index}-${i}`}>
                        {image.src.startsWith("Error") ? (
                          <View style={pdfStyles.row}>
                            <Text style={[pdfStyles.value, { borderBottom: "0px", color: "red" }]}>
                              {image.src} ({image.filename})
                            </Text>
                          </View>
                        ) : (
                          <View style={pdfStyles.imageContainer}>
                            <View style={pdfStyles.images_reference}>
                              <Image style={[pdfStyles.image, { width: "100%" }]} src={image.src} />
                            </View>
                          </View>
                        )}
                      </View>
                    ))}
                  </View>
                ) : (
                  <View style={pdfStyles.row}>
                    <Text style={[pdfStyles.label, { borderBottom: "0px" }]}>Images </Text>
                    <Text style={[pdfStyles.label_dot, { borderBottom: "0px" }]}>:</Text>
                    <Text style={[pdfStyles.value, { borderBottom: "0px" }]}>
                      Image not available
                    </Text>
                  </View>
                )}
              </View>
            ))}
          </View>

          <View style={[pdfStyles.footer]} fixed>
            <Text style={pdfStyles.footer_text}>
              Job id: {details.jobId} | Technician: {details.technicians}
            </Text>
          </View>
        </Page>
      </Document>
    );
  };

  const exportToPDF = async () => {
    setExportLoading(true);
    const pdfDocument = await NewDocument();
    if (pdfDocument) {
      const pdfBlob = await pdf(pdfDocument).toBlob();
      FileSaver.saveAs(pdfBlob, `${details.jobId}.pdf`);
    }
    setExportLoading(false);
  };

  const exportToExcel = async () => {
    setExportLoading(true);
    const allChapters = [];
    const imagesZip = new JSZip();
    const mainZip = new JSZip();
    let imagesAdded = false;

    const chapterPromises = chapters.map(async (chapter) => {
      const chapterName = chapter.name;
      const topicPromises = chapter.topics.map(async (topic) => {
        const topicData = {
          Chapter: chapterName,
          topic: topic.name,
          remarks: topic.remarks,
          topicImage: topic.images,
          results: getStatusText(topic.result),
        };

        if (
          (exportValue === "failed" && isTopicFailed(topic.result)) ||
          exportValue === "all"
        ) {
          if (topic.images) {
            const topicImages = await getImages(topic.images);
            const imageSrcs = await Promise.all(
              topicImages.map(async (image) => {
                const blobUrl = image.src;
                const imagePath = image.filename;

                if (blobUrl && blobUrl.startsWith("blob:")) {
                  try {
                    const response = await fetch(blobUrl);
                    const blob = await response.blob();
                    const imageName = `${imagePath}.jpg`;
                    imagesZip.file(imageName, blob);
                    imagesAdded = true;
                    return imageName;
                  } catch (error) {
                    console.error(`Error fetching image from ${blobUrl}:`, error);
                    return `Error: ${error.message}`;
                  }
                } else if (blobUrl.startsWith("Error")) {
                  return `${blobUrl} (${imagePath})`;
                } else {
                  console.warn(`Invalid or undefined Blob URL`);
                  return imagePath;
                }
              })
            );
            topicData["topicImage"] = imageSrcs.join(", ");
          }
          allChapters.push(topicData);
        }
      });
      await Promise.all(topicPromises);
    });

    await Promise.all(chapterPromises);

    if (allChapters.length > 0) {
      const csvBlob = await exportToCSVBlob(allChapters);
      mainZip.file(`${details.jobId}.xlsx`, csvBlob);
      if (imagesAdded) {
        const imagesZipContent = await imagesZip.generateAsync({ type: "blob" });
        mainZip.file("images.zip", imagesZipContent);
      }
      const mainZipContent = await mainZip.generateAsync({ type: "blob" });
      FileSaver.saveAs(mainZipContent, `${details.jobId}.zip`);
    } else {
      dispatch(setSnackbar(true, "info", "No data present in the file to export"));
    }

    setExportLoading(false);
  };

  const exportData = async () => {
    setExportOptions(false);
    setExportLoading(true);

    try {
      if (exportType === "pdf") {
        await exportToPDF();
      } else if (exportType === "excel") {
        await exportToExcel();
      } else {
        console.error("Invalid export type specified");
      }
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      setExportLoading(false);
    }
  };

  const handleChange = (panel) => {
    if (panel === "all") {
      setExpanded(!expanded);
    } else {
      setExpanded(expanded === panel ? false : panel);
    }
  };

  const renderAccordion = (chapter, index) => {
    const dataSet = chapter.topics;
    const isLast = index === chaptersData.length - 1;

    const getBadgeClass = (status) => {
      if (status === TOPIC_STATUS.PASS) return classes.badgeGreen;
      if (status === TOPIC_STATUS.FAIL) return classes.badgeRed;
      return classes.badgeYellow;
    };

    const isExpanded = expanded === `panel${index}` || expanded === true;

    return (
      <div className={`${classes.accordionItem}${isLast ? ` ${classes.accordionItemLast}` : ''}`}>
        <button
          className={classes.accordionTrigger}
          onClick={() => handleChange(`panel${index}`)}
        >
          <span>{chapter.name}</span>
          <Box style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <Chip
              label={`${chapter.topics.length} Topics`}
              size="small"
              style={{
                backgroundColor: "#dbeafe",
                color: "#1e40af",
                fontWeight: 600,
                fontSize: "11px !important",
                borderRadius: 12,
              }}
            />
            <KeyboardArrowDownIcon
              style={{
                transition: "transform 0.25s",
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                fontSize: "20px !important",
              }}
            />
          </Box>
        </button>
        <div
          className={classes.accordionContent}
          style={{ maxHeight: isExpanded ? "none" : "0px" }}
        >
          {dataSet.length > 0 ? (
            <div className={classes.tableWrap}>
              <table className={classes.table}>
                <thead>
                  <tr className={classes.tableHeadRow}>
                    <th style={{ width: "50%" }} className={classes.tableHeader}>Topics</th>
                    <th className={classes.tableHeader}>Status</th>
                    <th className={classes.tableHeader}>Remarks</th>
                    <th className={classes.tableHeader}>Pictures</th>
                    <th className={classes.tableHeader}>Reference</th>
                  </tr>
                </thead>
                <tbody>
                  {dataSet.map((row, i) => {
                    const status = getTopicStatus(row.result);
                    return (
                      <tr key={row.name || i} className={classes.tableRowHover}>
                        <td className={classes.tableCell}>
                          <span style={{ color: "#1a56db", fontWeight: 500 }}>
                            {row.name}
                          </span>
                        </td>
                        <td className={classes.tableCell}>
                          <span className={`${classes.badge} ${getBadgeClass(status)}`}>
                            {getStatusText(status)}
                          </span>
                        </td>
                        <td className={classes.tableCell}>
                          {row.remarks ? (
                            <span style={{ color: "#475569" }}>{row.remarks}</span>
                          ) : (
                            <span style={{ color: "#475569", letterSpacing: "3px", fontSize: "12px !important" }}>— — —</span>
                          )}
                        </td>
                        <td className={classes.tableCell}>
                          <button
                            className={classes.iconBtn}
                            title="View Pictures"
                            onClick={() => getImageView(row)}
                          >
                            <PhotoSizeSelectActualOutlinedIcon fontSize="small" />
                          </button>
                        </td>
                        <td className={classes.tableCell}>
                          <button
                            className={classes.iconBtn}
                            title="View Reference"
                            onClick={() => getPDFView(row)}
                          >
                            <AttachFileOutlinedIcon fontSize="small" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ padding: "16px 24px 20px", color: "#94a3b8", fontSize: "13px !important", fontStyle: "italic" }}>
              No topics available for this chapter.
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Dialog
        open={exportOptions}
        onClose={() => setExportOptions(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 15,
            boxShadow: "0 1px 4px rgba(0,0,0,0.06), 0 4px 20px rgba(0,0,0,0.05)",
            maxWidth: 400,
          },
        }}
      >
        <Box
          style={{
            padding: "14px 20px",
            borderBottom: "1px solid #f1f5f9",
            display: "flex",
            alignItems: "center",
            gap: 10,
            backgroundColor: "#F5F8FF",
          }}
        >
          <Box
            style={{
              width: 40,
              height: 40,
              borderRadius: 8,
              backgroundColor: "#dbeafe",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <GetAppIcon style={{ fontSize: "22px !important", color: "#1e40af" }} />
          </Box>
          <Typography
            style={{
              fontWeight: 700,
              fontSize: "16px !important",
              color: "#1a56db",
              textTransform: "uppercase",
              letterSpacing: 0.8,
            }}
          >
            Export Options
          </Typography>
        </Box>
        <DialogContent
          style={{
            padding: "18px 20px 0px 20px",
            display: "flex",
            flexDirection: "column",
            gap: 15,
          }}
        >
          <FormControl component="fieldset">
            <FormLabel
              style={{
                fontWeight: 600,
                color: "#64748b",
                fontSize: "13px !important",
                marginBottom: 6,
              }}
            >
              Type of document you want to export:
            </FormLabel>
            <RadioGroup
              value={exportType}
              onChange={(event) => setExportType(event.target.value)}
              style={{ display: "flex", flexDirection: "row", gap: 24 }}
            >
              <FormControlLabel
                value="excel"
                control={
                  <Radio
                    style={{
                      color: "#1a56db",
                      "&.Mui-checked": { color: "#1a56db" },
                    }}
                  />
                }
                label={
                  <span style={{ fontWeight: 500, color: "#0f172a" }}>Excel</span>
                }
              />
              <FormControlLabel
                value="pdf"
                control={
                  <Radio
                    style={{
                      color: "#1a56db",
                      "&.Mui-checked": { color: "#1a56db" },
                    }}
                  />
                }
                label={
                  <span style={{ fontWeight: 500, color: "#0f172a" }}>PDF</span>
                }
              />
            </RadioGroup>
          </FormControl>
          <FormControl component="fieldset">
            <FormLabel
              style={{
                fontWeight: 600,
                color: "#64748b",
                fontSize: "13px !important",
                marginBottom: 6,
              }}
            >
              Show all or only failed topics:
            </FormLabel>
            <RadioGroup
              value={exportValue}
              onChange={(event) => setExportValue(event.target.value)}
              style={{ display: "flex", flexDirection: "row", gap: 24 }}
            >
              <FormControlLabel
                value="all"
                control={
                  <Radio
                    style={{
                      color: "#1a56db",
                      "&.Mui-checked": { color: "#1a56db" },
                    }}
                  />
                }
                label={
                  <span style={{ fontWeight: 500, color: "#0f172a" }}>Show All</span>
                }
              />
              <FormControlLabel
                value="failed"
                control={
                  <Radio
                    style={{
                      color: "#1a56db",
                      "&.Mui-checked": { color: "#1a56db" },
                    }}
                  />
                }
                label={
                  <span style={{ fontWeight: 500, color: "#0f172a" }}>Only Failed</span>
                }
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions
          style={{
            padding: "8px 20px 12px 20px",
            justifyContent: "flex-end",
            gap: 4,
          }}
        >
          <Button
            onClick={() => setExportOptions(false)}
            style={{
              color: "#0f172a",
              backgroundColor: "white",
              textTransform: "none",
              fontWeight: 600,
              borderRadius: 8,
              border: "1px solid #cbd5e1",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disableElevation
            onClick={exportData}
            style={{
              textTransform: "none",
              backgroundColor: "#1d4ed8",
              color: "#fff",
              borderRadius: 8,
            }}
          >
            Export
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={onPdfClick}
        onClose={() => {
          setOnPdfClick(false);
          if (referenceHtmlUrl) {
            URL.revokeObjectURL(referenceHtmlUrl);
            setReferenceHtmlUrl(null);
          }
        }}
        maxWidth={"lg"}
        fullWidth={true}
        PaperProps={{
          style: {
            maxWidth: "85vw",
            borderRadius: 10,
          },
        }}
      >
        <iframe
          src={referenceHtmlUrl}
          title="Reference Manual"
          style={{ width: "100%", height: "90vh", border: "none" }}
        />
      </Dialog>

      <Viewer
        styles={{ zIndex: 99999 }}
        visible={imageVisible}
        onClose={() => {
          setImageVisible(false);
        }}
        images={inspectImages}
      />

      <Box className={classes.page}>
        {/* Header */}
        <Box className={classes.header}>
          <Box className={classes.headerLeft}>
            <Box className={classes.headerIcon}>
              <DescriptionIcon style={{ fontSize: "22px !important", color: "white" }} />
            </Box>
            <Typography variant="h5" className={classes.title}>
              Job Details
            </Typography>
          </Box>
          <Button
            variant="contained"
            className={classes.exportBtn}
            startIcon={<GetAppIcon />}
            onClick={() => setExportOptions(true)}
          >
            Export
          </Button>
        </Box>

        {/* Job Info Card */}
        <Card className={`${classes.card} ${classes.cardFlexContainer}`}>
          <Grid item xs={12} sm={2}>
            <img src={createInspectionJob} className={classes.gridImageContainer} />
          </Grid>
          <CardContent className={classes.cardContentContainer}>
            <Typography className={classes.infoTitle}>Job Information</Typography>

            <Box className={classes.fieldRow}>
              <Typography className={classes.fieldLabel}>Job ID</Typography>
              <Typography className={classes.fieldValue}>{details.jobId}</Typography>
            </Box>

            <Box className={classes.fieldRow}>
              <Typography className={classes.fieldLabel}>Technicians</Typography>
              <Typography className={classes.fieldValue1}>
                {details.technicians}
              </Typography>
            </Box>

            <Box className={classes.fieldRow}>
              <Typography className={classes.fieldLabel}>VIN</Typography>
              <Typography className={classes.fieldValue1}>
                {details.vin}
              </Typography>
            </Box>
          </CardContent>
        </Card>

        {/* More Details Card */}
        <Card className={classes.card}>
          <Box className={classes.moreDetailsHeader}>
            <Box className={classes.pageIconBox}>
              <MenuBookIcon className={classes.pageTitleIcon} />
            </Box>
            <Typography className={classes.moreDetailsTitle}>
              More Details
            </Typography>
          </Box>

          <Box className={classes.detailsGrid}>
            {[
              { label: "Model", value: details.modelName },
              { label: "Market", value: details.market },
              { label: "Year", value: details.year },
            ].map((item) => (
              <Box key={item.label} className={`${classes.detailCell} ${classes.detailCellWithBorder}`}>
                <Typography className={classes.detailCellLabel}>{item.label}</Typography>
                <Typography className={classes.detailCellValue}>{item.value}</Typography>
              </Box>
            ))}
          </Box>

          <Box className={classes.dividerLine} />

          <Box className={classes.detailsDates}>
            {[
              { label: "Plant", value: details.plantDetails },
              { label: "Start Date", value: details.inspectionDate ? moment(details.inspectionDate).format("DD/MM/YYYY") : "" },
              { label: "End Date", value: details.endDate ? moment(details.endDate).format("DD/MM/YYYY") : "" },
            ].map((item) => (
              <Box key={item.label} className={classes.detailCell}>
                <Typography className={classes.detailCellLabel}>{item.label}</Typography>
                <Typography className={classes.detailCellValue}>
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Box>
        </Card>

        {/* Chapter Information Card */}
        <Card className={classes.card}>
          <Box className={classes.chapterHeader}>
            <Box className={classes.moreDetailsHeader}>
              <Box className={classes.pageIconBox}>
                <MenuIcon className={classes.pageTitleIcon} />
              </Box>
              <Typography className={classes.moreDetailsTitle}>
                Chapter Information
              </Typography>
            </Box>
            <Box className={classes.chapterActions}>
              <Button
                variant="outlined"
                className={classes.expandBtn}
                onClick={() => handleChange("all")}
              >
                {expanded === true ? "Collapse All" : "Expand All"}
              </Button>
              <Box className={classes.radioGroup}>
                <Box
                  className={classes.radioOption}
                  onClick={() => {
                    setFilterStatus("notOk");
                    const data = _.cloneDeep(chapters);
                    data.forEach((a) => {
                      a.topics = a.topics.filter((g) => isTopicFailed(g.result));
                    });
                    let finalData = [];
                    finalData = data.filter((a) => a.topics.length !== 0);
                    setChaptersData(finalData);
                  }}
                >
                  <Box
                    className={`${classes.radioDot}${filterStatus === "notOk" ? " active" : ""
                      }`}
                    className={filterStatus === "notOk" ? `${classes.radioDot} ${classes.radioDotBorder}` : `${classes.radioDot} ${classes.radioDotBorderInactive}`}
                  >
                    {filterStatus === "notOk" && (
                      <Box
                        className={classes.radioDotActive}
                      />
                    )}
                  </Box>
                  View Failed
                </Box>
                <Box
                  className={classes.radioOption}
                  onClick={() => {
                    setFilterStatus("All");
                    const data = _.cloneDeep(chapters);
                    setChaptersData(data);
                  }}
                >
                  <Box
                    className={filterStatus === "All" ? `${classes.radioDot} ${classes.radioDotBorder}` : `${classes.radioDot} ${classes.radioDotBorderInactive}`}
                  >
                    {filterStatus === "All" && (
                      <Box
                        className={classes.radioDotActive}
                      />
                    )}
                  </Box>
                  View All
                </Box>
              </Box>
            </Box>
          </Box>

          {chaptersData.length > 0 ? (
            chaptersData.map((chapter, index) => renderAccordion(chapter, index))
          ) : (
            <Box className={classes.noRecordsContainer}>
              <Typography className={classes.noRecordsText}>No Records to Display</Typography>
            </Box>
          )}
        </Card>
      </Box>
    </>
  );
}
